import React, { useEffect, useState } from "react";
import * as S from "../../style/StyleComponentSection";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/Store";
import { get_brand_select, select_favorite_portfolio, select_favorite_portfolio_brand } from "../../Axios";
import Pagination from "../Utility/Pagination";
import PortfolioBoard from "./PortfolioBoard";

interface PortfolioList {
    ablack_comunity_ID            : number;
    ablack_comunity_brand_ID      : number;
    ablack_comunity_division_name : string;
    product_kor_name              : string;
    color_name                    : string;
    ablack_comunity_thumbnail_img : string;
    brand_kor_name                : string;
    product_eng_name              : string;
    ablack_comunity_status        : number;
};

interface BrandList {
    brand_ID       : number;
    brand_kor_name : string;
    brand_img      : string;
};

const CommunityFavorite: React.FC = () => {
    const customerData = useSelector((state: RootState) => state.customerData);
    const [page, setPage] = useState<number>(1);

    const [brandList, setBrandList] = useState<BrandList[]>([]);
    const [brandNumber, setBrandNumber] = useState<number>(0);
    const [totalFavoritePortfolio, setTotalFavoritePortfolio] = useState<number>(0);
    const [favoritePortfolioList, setFavoritePortfolioList] = useState<PortfolioList[]>([]);
    const [favoriteBrandList, setFavoriteBrandList] = useState<number[]>([]);

    useEffect(() => {
        handleSelectFavoritePortfolio();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [customerData.customer_ID, page, brandNumber]);

    const handleSelectFavoritePortfolio = () => {
        if(!customerData.customer_ID) return;
        select_favorite_portfolio(customerData.customer_ID, page, brandNumber).then(result => {
            let list: PortfolioList[] = result.rows;
            let list1 = list.filter(tmp => tmp.ablack_comunity_status === 1);
            setFavoritePortfolioList(list1);
            setTotalFavoritePortfolio(result.total_count);
        });
    };

    useEffect(() => {
        get_brand_select().then(result => {
            setBrandList(result);
        });
        if(customerData.customer_ID) {
            handleFavoritePortfolioBrand();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [customerData.customer_ID]);

    const handleFavoritePortfolioBrand = () => {
        select_favorite_portfolio_brand(customerData.customer_ID).then(result => {
            setFavoriteBrandList(result);
        });
    };

    const handlePage = (page: number) => {
        setPage(page);
    };
    
    return (
        <S.SectionContainer>
            <S.SectionWidth $width={1080}>
                <S.SectionTitleBox>
                    <h1>포트폴리오 즐겨찾기</h1>
                    <h3>즐겨찾기한 포트폴리오 내역을 확인할 수 있습니다.</h3>
                </S.SectionTitleBox>

                <div className="border-b-[0.5px] border-solid border-middleGray02"></div>
                <S.CommunityCategoryBox>
                    <S.CommunityBrandButton $btnSelect={brandNumber === 0 ? true : false} onClick={() => setBrandNumber(0)}>
                        전체
                    </S.CommunityBrandButton>
                    {brandList.filter((tmp) => favoriteBrandList.includes(tmp.brand_ID)).map((tmp, idx) =>
                        <S.CommunityBrandButton key={idx} $btnSelect={brandNumber === tmp.brand_ID ? true : false} onClick={() => {
                            setBrandNumber(tmp.brand_ID);
                        }}>
                            {tmp.brand_kor_name}
                        </S.CommunityBrandButton>
                    )}
                </S.CommunityCategoryBox>
                <div className="border-b-[0.5px] border-solid border-middleGray02"></div>
                
                {favoritePortfolioList.length < 1 &&
                    <S.EmptyContentBox>
                        <p>해당 조건과 일치하는 결과가 없습니다.</p>
                    </S.EmptyContentBox>
                }

                <PortfolioBoard portfolioList={favoritePortfolioList} handleSelectFavoritePortfolio={handleSelectFavoritePortfolio} handleFavoritePortfolioBrand={handleFavoritePortfolioBrand} />

                <br />
                <br />
                <Pagination totalCount={totalFavoritePortfolio} handlePage={handlePage} listCount={15} page={page} />
                <br />
                <br />
            </S.SectionWidth>
        </S.SectionContainer>
    )
};

export default CommunityFavorite;